import { IconButton } from '@chakra-ui/react'
import type { FC } from 'react'
import { PiBook } from 'react-icons/pi'
import { useNavigate } from 'react-router-dom'

import { Tooltip } from '@app/components/ui/tooltip'
import useStoreCurrentUser from '@app/hooks/useStoreCurrentUser'
import { useStrategyMapContext } from '@app/pages/strategies/strategyMapContext'
import Can from '@app/shared/authorization/can'
import { usePlaybookCreateFromStrategyMutation } from '@graphql/queries'
import type { Strategy } from '@graphql/types'

interface Props {
  strategy: Pick<Strategy, 'id'>
  show?: boolean
}

const PlaybookCreateButton: FC<Props> = ({ strategy, show = true }) => {
  const navigate = useNavigate()
  const { user } = useStoreCurrentUser()
  const { canEdit } = useStrategyMapContext()
  const [, createPlaybook] = usePlaybookCreateFromStrategyMutation()

  if (!user || !show || !canEdit) {
    return null
  }

  const onClick = () =>
    createPlaybook({
      input: {
        strategyId: strategy.id
      }
    }).then(
      ({
        data: {
          playbookCreateFromStrategy: {
            playbook: { id }
          }
        }
      }) => {
        navigate(`/playbooks/${id}`)
      }
    )

  return (
    <Can I="view" an="admin">
      <Tooltip content="Create a playbook" showArrow>
        <IconButton fontSize="lg" aria-label="Create playbook" colorPalette="gray" onClick={onClick} variant="ghost">
          <PiBook />
        </IconButton>
      </Tooltip>
    </Can>
  )
}

export default PlaybookCreateButton
